
import { Tabs } from 'antd';
import { useEffect, useState, useCallback } from 'react';
import { getODSs, updateODSs } from '../../services/distributionsystem';
import Loading from '../Loading';
import ODSForm from './components/ODSForm';
import ODSTable from './components/ODSTable';

const { TabPane } = Tabs

const OtherDistributionSystemPage = () => {

    const { supplier, propertyId } = JSON.parse(sessionStorage.getItem('session') as string)
    const [loading, setLoading] = useState<boolean>(true)
    const [ODSData, setODSData] = useState([])
    const [keyword, setKeyword] = useState('')
    const [currentRecord, setCurrentRecord] = useState(null)

    const gettingOds = useCallback(async() => {
        const res = await getODSs(supplier, propertyId)
        res.result.success && setODSData(res.property.otherdistributionsystems)
        setLoading(false) 
    },[propertyId, supplier])

    useEffect(() => {
        gettingOds()            
    }, 
    [gettingOds])

    const handleUpdate = async (data: object[]) => {
        try {
            setLoading(true) 
            const ODS = { supplier, propertyId, property: { otherdistributionsystems: [...data] } }
            const response = await updateODSs(ODS)
            setODSData(response.property.otherdistributionsystems)
            return setLoading(false) 
        } catch (error) {
            throw new Error(`other distribution systems - ${error}`)
        }
    }

    const handleSearch = (v: string) => {
        setKeyword(v.toLowerCase())
    }

    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Other Distribution Systems" key="1">
                {currentRecord ?
                    <ODSForm record={currentRecord} handleSubmit={handleUpdate} setCurrentRecord={setCurrentRecord}/> :
                    loading ?
                        <Loading type="large" /> :
                        <ODSTable data={ODSData.filter((item: { name: string }) => JSON.stringify(item).toLowerCase().includes(keyword))} onRowClick={setCurrentRecord} onSearch={handleSearch} />
                }
            </TabPane>
        </Tabs>
    )
}

export default OtherDistributionSystemPage
